import logoVca from "../../../assets/images/Ellipse 4442 1.png";
import logoBaroda from "../../../assets/images/Ellipse 4443 1.png";
import logoGopro from "../../../assets/images/Ellipse 4445 1.png";
import logoCabi from "../../../assets/images/Ellipse 4444 1.png";
import logoDarshanam from "../../../assets/images/Ellipse 4439 1.png";
import awsLogo from "../../../assets/images/aws.png";
// import logoSpark from '../../../assets/images/Ellipse 4430 1.png';
import logoSeattle from "../../../assets/images/Ellipse 4429 1.png";

export const logoMarqueeItems = [
  { name: "VCA Vadodara Cricket Academy", src: logoVca },
  { name: "Baroda Cricket Association", src: logoBaroda },
  { name: "GoPro", src: logoGopro },
  { name: "Cricket Association for the Blind in India", src: logoCabi },
  { name: "Darshanam", src: logoDarshanam },
  { name: "aws", src: awsLogo },
  { name: "Seattle Thunderbolts", src: logoSeattle },
];
